import List from "./components/List";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "./styles/styles.css";

function App() {
  return (
    <div className="app">
      <List />
    </div>
  );
}

export default App;
